module.exports = __webpack_public_path__ + "img/img_throw_3@3x_v2.8c050ce6.png";